/** Task names may wrap words in **double asterisks** to show them in bold —
 *  the automatic brand-contact tasks bold their brand names that way
 *  (backend: campaigns/partner_tasks.py, tasks/markup.py). */
const BOLD = /\*\*(.+?)\*\*/g;

/** The name without the asterisks — for toasts, titles and other plain text. */
export const plainTaskName = (name: string): string => name.replace(BOLD, '$1');

export function TaskName({ name }: { name: string }) {
  const parts = name.split(BOLD);
  // split() with a capture group alternates: plain, bold, plain, bold, …
  return <>{parts.map((part, i) => (i % 2 === 1 ? <strong key={i}>{part}</strong> : part))}</>;
}
